var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "21px",
    viewBox: "0 0 17.0 21.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "support_i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420,0 L420,1738 L0,1738 L0,0 L420,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "support_i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0 C13.19,0 17,3.81 17,8.5 C17,13 13.86,17.66 9,20 L9,17 L8.5,17 C3.81,17 0,13.19 0,8.5 C0,3.81 3.81,0 8.5,0 Z M9.5,12.5 L7.5,12.5 L7.5,14.5 L9.5,14.5 L9.5,12.5 Z M8.5,2 C6.29,2 4.5,3.79 4.5,6 L6.5,6 C6.5,4.9 7.4,4 8.5,4 C9.6,4 10.5,4.9 10.5,6 C10.5,8 7.5,7.75 7.5,11 L9.5,11 C9.5,8.75 12.5,8.5 12.5,6 C12.5,3.79 10.71,2 8.5,2 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-131.0 -1006.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#support_i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.99999999999858 1004.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.0 2.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#support_i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,0 17,0 17,20 0,20 0,0",
    stroke: "none",
    fill: "currentColor"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.fe20bfeca40fde58d2553ad5b9cc23de.svg";
export { ForwardRef as ReactComponent };